import { render, staticRenderFns } from "./AddExistingFolderGroup.vue?vue&type=template&id=1b389954&scoped=true"
import script from "./AddExistingFolderGroup.vue?vue&type=script&lang=js"
export * from "./AddExistingFolderGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b389954",
  null
  
)

export default component.exports